import store from '@/scripts/store';

const getPlatformIconUrl = (name, field = 'image') => {
  if (!name) return null;

  const { state = {} } = store;
  const { games = [] } = state;
  const allPossiblePlatforms = [];

  if (!games || !games.length) return null;

  games.forEach(({ platforms }) => {
    allPossiblePlatforms.push(...platforms);
  });

  const currentPlatformSetup = allPossiblePlatforms.find(
    ({ id }) => id === name
  );

  if (!currentPlatformSetup) return null;

  const result = currentPlatformSetup[field].url;

  return result;
};

/*  */
export { getPlatformIconUrl };
